import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import { Alert, Button } from 'react-bootstrap';
import api from '../helpers/ApiClient';
import qs from 'qs';
import ReactTooltip from 'react-tooltip'
import Loader from '../components/Loader';

class Feedback extends Component {

    constructor(props) {
        super(props);

        let name, email, subject, message, submitted, loading

        this.state = {
            name,
            email,
            subject,
            message,
            submitted,
            loading
        };
    }

    handleFeedback = () => {

        let { name, email, subject, message } = this.state;

        this.setState({ loading: true });        

        return api('/api/feedback', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name,
                email,
                subject,
                message
            })
        }).then(result => {

            this.setState({ loading: false });        

            if(result){
                this.setState({ 
                submitted: true });        
            }
        })
    }

    handleNameChange = (event) => {
        this.setState({ name: event.target.value });
    }

    handleEmailChange = (event) => {
        this.setState({ email: event.target.value });
    }

    handleSubjectChange = (event) => {
        this.setState({ subject: event.target.value });
    }

    handleMessageChange = (event) => {
        this.setState({ message: event.target.value });
    }

//     Name
// Email Address
// Subject: (drop-down)
// - Suggestion
// - Report Bugs
// - Other
// Message

    render() {
        const { error } = this.props
        const { submitted, loading } = this.state;
    
        return (
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div>
                            {
                                error &&
                                <Alert bsStyle="danger">
                                    <div>{error}</div>
                                </Alert>
                            }
                            <h3>Feedback</h3>
                            <div className="form-group">
                                <input className="form-control" name="name" placeholder="Name" type="text" onChange={this.handleNameChange}/>
                            </div>
                            <div className="form-group">    
                                <input className="form-control" email="email" placeholder="Email Address" type="email" onChange={this.handleEmailChange}/>
                            </div>
                            <div className="form-group">    
                                <select className="form-control" name="subject" onChange={this.handleSubjectChange}>
                                    <option disabled selected hidden>Please select your feedback type</option>
                                    <option value="Suggestion">Suggestion</option>
                                    <option value="Report Bugs">Report Bugs</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                            <div className="form-group">    
                                <textarea className="form-control" name="message" placeholder="Message" onChange={this.handleMessageChange}/>
                            </div>
                            <Button disabled={submitted || loading} className="btn-postcode-checker" onClick={this.handleFeedback} block>{loading? "Submitting" : submitted ? "Submitted" : "Submit"}</Button>                    
                            {
                                submitted &&
                                <div><p>Thank you for your feedback.</p></div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect((state, props) => {

    return {
        
    };
})(Feedback);